import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '../../utils/cn';
export interface SubNavItem {
  to: string;
  label: string;
}
export function SubNav({
  items,
  className
}: {
  items: SubNavItem[];
  className?: string;
}) {
  return <nav aria-label="Section" className={cn('no-scrollbar -mx-1 flex gap-1 overflow-x-auto', className)} data-id="element-894" data-mp="1xenwj7rygolz">
      {items.map(item => <NavLink key={item.to} to={item.to} end className={({
      isActive
    }) => cn('shrink-0 rounded-full px-3.5 py-2 text-[13px] font-medium transition-colors duration-150 ease-out', isActive ? 'bg-primary text-on-primary' : 'text-ink-2 hover:bg-oat hover:text-ink')} data-id="element-895" data-mp="1obmtjfydzdmj">
          {item.label}
        </NavLink>)}
    </nav>;
}
export const studioNav: SubNavItem[] = [{
  to: '/chef/studio/menus',
  label: 'Menus & rates'
}, {
  to: '/chef/studio/areas',
  label: 'Service areas'
}, {
  to: '/chef/studio/availability',
  label: 'Availability'
}, {
  to: '/chef/studio/profile',
  label: 'Profile & verification'
}];
export const accountNav: SubNavItem[] = [{
  to: '/app/account/profile',
  label: 'Profile'
}, {
  to: '/app/account/dietary',
  label: 'Dietary'
}, {
  to: '/app/account/kitchen',
  label: 'Kitchen'
}, {
  to: '/app/account/payments',
  label: 'Payments'
}];